export const LocalizationLanguages = {
  en: {
    locale: 'en',
    country: 'GB', // used for flags
    label: 'English',
  },
  de: {
    locale: 'de',
    country: 'DE',
    label: 'Deutsch',
  },
  es: {
    locale: 'es',
    country: 'ES',
    label: 'Español',
  },
  ru: {
    locale: 'ru',
    country: 'RU',
    community: true,
    label: 'Русский',
  },
  vi: {
    locale: 'vi',
    country: 'VN',
    community: true,
    label: 'Tiếng Việt',
  },
  pl: {
    locale: 'pl',
    country: 'PL',
    label: 'Polski',
  },
  fr: {
    locale: 'fr',
    country: 'FR',
    label: 'Français',
  },
  pt: {
    locale: 'pt',
    country: 'PT',
    label: 'Português',
  },
  tr: {
    locale: 'tr',
    country: 'TR',
    label: 'Türkçe',
  },
  sk: {
    locale: 'sk',
    country: 'SK',
    label: 'Slovenský',
  },
  cs: {
    locale: 'cs',
    country: 'CZ',
    label: 'Čeština',
  },
  ar: {
    locale: 'ar',
    country: 'AE',
    label: 'عربي',
  },
  el: {
    locale: 'el',
    country: 'GR',
    label: 'ελληνικά',
  },
  it: {
    locale: 'it',
    country: 'IT',
    label: 'Italiano',
  },
  ch: {
    locale: 'ch',
    county: 'CH',
    label: 'CH л̑àńğůàğё',
  },
};

export const supportedLanguages = [
  'en',
  'es',
  'fr',
  'de',
  'pt',
  'ru',
  'tr',
  // 'pl',
  // 'sk',
  'ar',
  // 'el',
  'vi',
  // 'fr',
  // 'it',
];
